import { TableFilterType } from 'features/TableFilter';
import { WarehouseListFilters } from '../../model/types';

export const transformWarehouseListFilters = ({ franchiseId }: TableFilterType): WarehouseListFilters => {
  return {
    franchiseId: franchiseId?.value || undefined,
  };
};
